/**
 * 클래스명 결합 유틸
 *
 * Tailwind 클래스 충돌 시 뒤의 클래스가 우선되도록 tailwind-merge 사용
 *
 * 사용법:
 *   <div className={cn('ml-px-4', isPrimary && 'ml-bg-brand-600', className)} />
 */

import clsx, { type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * 시간 포맷팅
 */
export function formatTime(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleTimeString('ko-KR', {
    hour: '2-digit',
    minute: '2-digit',
  });
}

/**
 * 날짜 포맷팅 (한국 시간 기준)
 */
export function formatDate(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleDateString('ko-KR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
}

/**
 * 짧은 ID 생성 (메시지 ID 등)
 */
export function generateId(prefix = 'id'): string {
  const random = Math.random().toString(36).slice(2, 10);
  const timestamp = Date.now().toString(36);
  return `${prefix}_${timestamp}_${random}`;
}

/**
 * HTML 이스케이프 (XSS 방지용)
 *
 * 답변 텍스트에 사용자 입력이 끼어드는 일은 없지만,
 * 만일을 위한 방어적 코딩.
 */
export function escapeHtml(str: string): string {
  return str.replace(/[&<>"']/g, (c) => {
    const map: Record<string, string> = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    };
    return map[c] ?? c;
  });
}

/**
 * 줄바꿈 텍스트를 React 노드로 변환
 *
 * 답변 텍스트의 \n을 <br>로 안전하게 변환
 */
export function nl2br(text: string): string[] {
  return text.split('\n');
}
